import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_TARIFGAM_SCHEMA_LITERAL = {
    title: 'Schéma F_TARIFGAM',
    description: 'F_TARIFGAM',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        AR_REF: { type: 'string' },
        TG_REFCF: { type: 'string' },
        AG_NO1: { type: 'number' },
        AG_NO1LIB: { type: 'string' },
        AG_NO2: { type: 'number' },
        AG_NO2LIB: { type: 'string' },
        TG_PRIX: { type: 'number' },
        TG_CODEBARRE: { type: 'string' }
    },
    required: [ 'CBMARQ', 'AR_REF', 'TG_REFCF', 'AG_NO1', 'AG_NO2' ] //
} as const;

const schemaTyped = toTypedRxJsonSchema(F_TARIFGAM_SCHEMA_LITERAL);
export type RxFTarifGamDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_TARIFGAM_SCHEMA: RxJsonSchema<RxFTarifGamDocumentType> = F_TARIFGAM_SCHEMA_LITERAL;
